import { connect } from 'react-redux'
import find from 'lodash/find'

import FooterLayoutOne from 'components/home-page/views/sections/footer/layouts/one'
import fontFamilies from 'configs/font-families'

const mapStateToProps = (state, ownProps) => {
  const fetchedContentFont = find(fontFamilies, (f) => f.key === state.theme.theme.contentFont)

  const fetchedProps = {
    meta: state.homePageRevision.revision.sections[ownProps.sectionId].meta,
    data: state.homePageRevision.revision.sections[ownProps.sectionId].data[0],
    backgroundColor: state.homePageRevision.revision.sections[ownProps.sectionId].theme.backgroundColor,
    textColor: state.homePageRevision.revision.sections[ownProps.sectionId].theme.textColor,
    fontFamily: (fetchedContentFont && fetchedContentFont.name) || fontFamilies[0].name,
    links: state.adminFooterLinks.footerLinks
  }

  return fetchedProps
}

export default connect(mapStateToProps)(FooterLayoutOne)
